import c from "./nativeAdScrollerCapmaign.module.scss";
import Helpers from "../helpers/Helpers";
import utstillere from "../store/sjoenForAlle-utstillere";
import {Link, useLocation} from "react-router-dom";
import ArrowRightIcon from "../svg/ArrowRightIcon";
import {useEffect} from "react";
import logoImg from "../batens_verden/images/sjoenforalle-logo2.png";
import c2 from "./nativeAdScrollerCapmaign.module.scss";
import advertService from "../services/AdvertService";
import helpers from "../helpers/Helpers";


function SingleNative({ad}) {
	if (Array.isArray(ad)) {
		ad = helpers.getRandomFromArray(ad);
	}
	return <a href={ad.l} target={"_blank"} className={c2.singleNative} style={{color:ad.color||null}} onClick={()=>{advertService.incrementTempad(`SFA-Native- ${ad.firm} - ${ad.description}`)}}>
		<img className={c2.image} src={ad.wideImage} loading={'lazy'}/>
		<div className={c2.description} style={{background:ad.bg||''}}>
			<div className={c2.text1} style={{fontSize:ad.fontSize||''}} dangerouslySetInnerHTML={{__html:ad.description}}></div>
			<div className={c2.textBrandName} style={{background:ad.logoBg||'',color:ad.logoColor||''}}>{ad.firm}</div>
		</div>
	</a>
}

export default function NativeAdScrollerCampaign({showMagazineLink=true}) {
	useEffect(() => {
		const swiperEl = document.getElementById("my-swiper");

		const handleMouseEnter = () => {
			swiperEl.swiper.autoplay.stop();
		};

		const handleMouseLeave = () => {
			swiperEl.swiper.autoplay.start();
		};

		swiperEl.addEventListener("mouseenter", handleMouseEnter);
		swiperEl.addEventListener("mouseleave", handleMouseLeave);

		return () => {
			swiperEl.removeEventListener("mouseenter", handleMouseEnter);
			swiperEl.removeEventListener("mouseleave", handleMouseLeave);
		};
	}, []);

	const location = useLocation();

	return <div className={[c.root, 'contentBlock'].join(' ')}>
		<div className={c.headerText}>
			<img src={logoImg}/>
			<span>Møt utstillerne</span>
			{showMagazineLink&&<Link to={`/sjoen-for-alle${location.search}`} className={c.readMagazine}>Les messemagasinet <ArrowRightIcon height={'2em'}/>
			</Link>}
		</div>

		<swiper-container
			id={"my-swiper"}
			autoplay="true"
			autoplay-delay="2600"
			autoplay-rewind="true"
			autoplay-disable-on-interaction="true"
			loop={true}
			space-between="10"
			slides-per-view="auto"
			grab-cursor="true"
			direction="horizontal"
			navigation="true"
			style={{ width: '100%', height: 'fit-content', maxWidth: '100%' }}
		>
			{Helpers.randomizeArray(utstillere).map((ad) => <swiper-slide style={{flexShrink: 0,width:'300px'}}>
				<SingleNative ad={ad}/>
			</swiper-slide>)}
		</swiper-container>

		<Link className={c.showMore} target={"_blank"} to={`/sjoen-for-alle-utstillere${location.search}`}>
			<span className={c.showMoreLine}></span>
			<span className={c.showMoreText}>Vis mer<span className={c.showMoreArrow}><ArrowRightIcon/></span></span>
			<span className={c.showMoreLine}></span>
		</Link>
	</div>
}